export const splitLocale = locale => {
  const [lang, scriptOrRegionOrNothing, regionOrNothing] = locale.split(/[-_]/);
  // BCP-47 requires that script subtags must be 4 characters long
  // and that region subtags must be 2 or 3 characters.
  let script = '';
  let region = '';
  if (scriptOrRegionOrNothing) {
    if (scriptOrRegionOrNothing.length === 4) {
      script = scriptOrRegionOrNothing;
      region = regionOrNothing !== null && regionOrNothing !== void 0 ? regionOrNothing : '';
    } else {
      region = scriptOrRegionOrNothing;
    }
  }
  if (region.length !== 2 && region.length !== 3) {
    region = '';
  }

  // Convention is that language is lowercase, region is uppercase, and script is only first
  // letter is uppercase.
  const normalizedScript = script === '' ? '' : script[0].toUpperCase() + script.substring(1).toLowerCase();
  return {
    lang: lang.toLowerCase(),
    script: normalizedScript,
    region: region.toUpperCase()
  };
};
export const normalizeLocaleParts = parts => {
  let locale = parts.lang;
  if (parts.script) {
    locale += `-${parts.script}`;
  }
  if (parts.region) {
    locale += `-${parts.region}`;
  }
  return locale;
};
export const normalizeLocaleString = locale => {
  const localeWithDashes = locale.replace('_', '-');
  const normalizedLocale = normalizeLocaleParts(splitLocale(localeWithDashes));
  if (localeWithDashes.toLowerCase().indexOf('pseudo') > -1) {
    // The '-pseudo' is stripped out in splitLocale. Add it back here.
    return `${normalizedLocale}-pseudo`;
  }
  if (localeWithDashes.endsWith('-x-rtl')) {
    return `${normalizedLocale}-x-rtl`;
  }
  return normalizedLocale;
};
export const isThaiLocale = locale => {
  if (locale === 'th' || locale === 'th-TH') return true;
  return false;
};
export const isArSaLocale = locale => {
  if (locale === 'ar-SA') return true;
  return false;
};
export const toLatinNumberingSystemLocale = locale => {
  // For a true implementation should probably also replace any existing number system but I don't think in SAS we're
  // specifying other numbering systems.
  if (locale.includes('-u-nu-latn')) return locale;
  const x = ['ar', 'bn', 'fa', 'mr'];
  return x.includes(locale.substring(0, 2)) ? `${locale}-u-nu-latn` : locale;
};
//# sourceMappingURL=localeUtils.js.map